import * as _ from 'lodash';
import { Action, Reducer } from 'redux';
import { ActionStateType } from '../actions';

type ReducerState = number;
type ReducerAction = Action;

const initialState: number = 0;

export const ongoingActions: Reducer<ReducerState> = (state: ReducerState = initialState, action: ReducerAction): ReducerState => {
    if (_.endsWith(action.type, ActionStateType.InProgress)) {
        return state + 1;
    } else if (_.endsWith(action.type, ActionStateType.Success) || _.endsWith(action.type, ActionStateType.Fail)) {
        return Math.max(0, state - 1);
    } else {
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/ongoingActions.ts